import { useStore } from 'vuex'
import Man from '@/assets/images/categories/man.jpg'
import Woman from '@/assets/images/categories/woman.jpg'
import Kid from '@/assets/images/categories/kid.jpg'
import DefaultImg from '@/assets/images/shop/trendy-t-shirt2.jpg'

export const useDataInit = () => {
  const store = useStore()

  //AQUI SE PUEDE LLAMAR AL SERVICIO Y SETEAR DATOS GENERALES
  //A MODO DE EJEMPLO:
  const defaultBannersTop = [
    {
      image: Woman,
      name: 'Ropa para mujeres',
      url: '/productos/SKU-01'
    },
    {
      image: Kid,
      name: 'Ropa de niños',
      url: '/productos/SKU-02'
    },
    {
      image: Man,
      name: 'Ropa para hombres',
      url: '/productos/SKU-03'
    },
  ]

  const productsExamples = [
    {
      image: DefaultImg,
      cart: 'Agregar al carrito',
      status: 'IN_DISCOUNT',
      percentage: 40,
      name: 'Trendy T-shirt',
      price: 16,
      price2: 21,
      SKU: 'SKU001',
    },
    {
      image: DefaultImg,
      cart: 'Agregar al carrito',
      status: 'NEW',
      percentage: 0,
      name: 'Men Sun Glasses',
      price: 16,
      price2: 0,
      SKU: 'SKU002',
    },
    {
      image: DefaultImg,
      cart: 'Agregar al carrito',
      status: 'REGULAR',
      percentage: 0,
      name: 'Women White Low Heel Shoes',
      price: 16,
      price2: 0,
      SKU: 'SKU003',
    },
    {
      image: DefaultImg,
      cart: 'Agregar al carrito',
      status: 'REGULAR',
      percentage: 0,
      name: 'Black Print T-Shirt',
      price: 16,
      price2: 0,
      SKU: 'SKU004',
    },
    {
      image: DefaultImg,
      cart: 'Agregar al carrito',
      status: 'REGULAR',
      percentage: 0,
      name: 'Orange Luxurious Bag',
      price: 16,
      price2: 0,
      SKU: 'SKU005',
    },
    {
      image: DefaultImg,
      cart: 'Agregar al carrito',
      status: 'REGULAR',
      percentage: 0,
      name: 'Smart Watch',
      price: 16,
      price2: 0,
      SKU: 'SKU006',
    },
    {
      image: DefaultImg,
      cart: 'Agregar al carrito',
      status: 'FEATURED',
      percentage: 0,
      name: 'White Sandals',
      price: 16,
      price2: 0,
      SKU: 'SKU007',
    },
    {
      image: DefaultImg,
      cart: 'Ladies Skirt',
      status: '',
      name: 'Sweater T-Shirt',
      price: 16,
      price2: 0,
      SKU: 'SKU008',
    },
  ]

  store.dispatch('data/setDataBrandsTopHome', {
    banners: defaultBannersTop,
  })

  store.dispatch('data/setDataTrenddingProductsHome', {
    products: productsExamples,
  })

  store.dispatch('data/setDataSellersProductsHome', {
    products: productsExamples,
  })
}
